import { AfterViewInit, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BallotSearchService } from '../../services/ballot-search.service';
import { IOption } from '../../../../controls/models/option';
import { Subscription } from 'rxjs';
import { IBallotTypeEnumValue } from '../../../../../shared/models/connect-enum';

@Component({
    selector: 'app-select-multiple-ballot-type',
    templateUrl: './select-multiple-ballot-type.component.html',
    styleUrl: './select-multiple-ballot-type.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectMultipleBallotTypeComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectMultipleBallotTypeComponent implements ControlValueAccessor, OnInit, OnDestroy, AfterViewInit {
  
  @Input() id: string = 'select-ballot-type';
  @Input() label: string = 'Filter by Type';
  @Output() viewLoaded = new EventEmitter<void>();

  onChange: any = () => { };
  onTouched: any = () => { };
  isDisabled: boolean = false;

  options: IOption<number>[] = [];


  private _values: any[] | undefined;
  get values() {
    return this._values;
  }
  set values(values) {
    this._values = values;
    this.onChange(values);
  }

  subscriptions: Subscription = new Subscription();

  constructor(private _ballotSearchService: BallotSearchService) { 

  }


  ngOnInit(): void {
    this.getBallotTypes();
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.viewLoaded.emit();
  }
  
  writeValue(values: any[]): void {
    this._values = values ? values : [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  getBallotTypes(): void {
    this.subscriptions.add(
      this._ballotSearchService.getBallotTypeEnums().subscribe({
        next: (ballotTypeResponse) => {
          if(ballotTypeResponse && ballotTypeResponse.success) {
            const options = ballotTypeResponse.content.map(
              (ballotType: IBallotTypeEnumValue) => {
                return {
                  value: ballotType.id,
                  label: ballotType.displayText,
                };
              }
            );
            this.options = options;
          } else {
            console.error('Error getting ballot types', ballotTypeResponse.message);
          }
        },
        error: (error) => {
          console.error('Error getting ballot types', error);
        }
      })
    );
  }

}
